import SectionLabel from '@/components/ui/SectionLabel'
import VideoThumbnail from '@/components/VideoThumbnail'
import RichText from '@/components/RichText'
import { HERO_IMAGE_URL } from '@/data/media'
import { VALEURS } from '@/data/valeurs'
import { useContent } from '@/hooks/useContent'
import { imageRedimensionnee } from '@/helpers/images'

export default function AProposPage() {
  const { equipe, motDuPasteur } = useContent()

  return (
    <div>
      <section className="relative text-white px-6 py-16 md:py-24 text-center overflow-hidden">
        {/* Photo de l'assemblée — image Unsplash de PRÉVISUALISATION (voir data/media.ts). */}
        <img src={HERO_IMAGE_URL} alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-linear-to-b from-cmp-navy-dark/90 via-cmp-navy/75 to-cmp-navy-dark/95" />
        <div
          className="absolute inset-0"
          style={{
            backgroundImage:
              'radial-gradient(ellipse 60% 50% at 20% 20%, rgba(201,147,47,0.2) 0%, transparent 100%)',
          }}
        />

        <div className="relative z-10 max-w-xl mx-auto">

          <p className="text-cmp-gold-light text-xs font-bold uppercase tracking-[0.2em] mt-6 mb-3">
            Qui sommes-nous
          </p>
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold leading-tight tracking-tight text-balance">
            À propos du CMP Lubumbashi
          </h1>
          <p className="text-white/80 text-base md:text-lg leading-relaxed mt-4 max-w-md mx-auto">
            Notre vision, notre histoire, ce que nous croyons, et les personnes qui portent
            cette église au quotidien.
          </p>
        </div>
      </section>

      {/* Notre vision */}
      <section className="px-4 py-14 md:py-20 bg-white">
        <div className="max-w-2xl mx-auto text-center">
          <SectionLabel>Notre vision</SectionLabel>
          <p className="font-serif text-2xl md:text-4xl font-medium text-cmp-navy leading-snug mt-5 text-balance">
            « Bâtir à Dieu un peuple saint, un peuple qui adore. »
          </p>
        </div>
      </section>

      {/* Nos valeurs */}
      <section className="px-4 py-14 md:py-20 bg-cmp-cream">
        <div className="max-w-3xl mx-auto text-center">
          <SectionLabel>Ce qui nous porte</SectionLabel>
          <h2 className="text-2xl md:text-3xl font-bold text-cmp-navy mt-3 mb-10">Nos valeurs</h2>

          <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4">
            {VALEURS.map((valeur, i) => (
              <span key={valeur} className="flex items-center gap-3 md:gap-4">
                <span className="font-bold text-cmp-navy text-lg md:text-xl uppercase tracking-wide">
                  {valeur}
                </span>
                {i < VALEURS.length - 1 && <span className="text-cmp-gold text-lg" aria-hidden="true">·</span>}
              </span>
            ))}
          </div>
        </div>
      </section>

      {/* Mot du pasteur — texte et vidéo modifiables depuis /admin. Le texte sert de transcription. */}
      <section id="mot-du-pasteur" className="px-4 py-14 md:py-20 bg-white">
        <div className="max-w-2xl mx-auto">
          <SectionLabel>Mot du pasteur</SectionLabel>

          {motDuPasteur.videoId ? (
            <VideoThumbnail
              thumbnail={imageRedimensionnee(motDuPasteur.photo, 1280, 720, true)}
              title="Mot du pasteur"
              videoId={motDuPasteur.videoId}
              className="mt-6 w-full aspect-video rounded-3xl rounded-tl-4xl shadow-lg"
            />
          ) : (
            <img
              src={imageRedimensionnee(motDuPasteur.photo, 320)}
              alt={motDuPasteur.nom}
              loading="lazy"
              className="mt-6 w-40 h-40 mx-auto object-cover rounded-3xl rounded-tl-4xl shadow-lg"
            />
          )}

          <div className="mt-8">
            {motDuPasteur.videoId && (
              <p className="text-cmp-gold text-xs font-bold uppercase tracking-widest mb-4">Transcription</p>
            )}
            <div className="text-[15px] md:text-base text-left">
              <RichText>{motDuPasteur.texte}</RichText>
            </div>
          </div>
        </div>
      </section>

      {/* Histoire */}
      <section className="px-4 py-14 md:py-20 bg-cmp-cream">
        <div className="max-w-2xl mx-auto text-center">
          <SectionLabel>D'où nous venons</SectionLabel>
          <h2 className="text-2xl md:text-3xl font-bold text-cmp-navy mt-3 mb-6">Notre histoire</h2>
          <div className="text-gray-600 leading-relaxed text-[15px] md:text-base space-y-4 text-left">
            <p>
              Nous sommes le Centre Missionnaire Philadelphie Lubumbashi, une extension du Centre
              Missionnaire Philadelphie, œuvre membre de la 37ème CADC dont l'apôtre Roland DALO
              est le visionnaire, et qui est aujourd'hui dirigée par le pasteur Ken Luamba.
            </p>
            <p>
              CMP Lubumbashi a commencé le 19 juin 2016, sous la conduite du Pasteur Timothée
              MBENGELA.
            </p>
          </div>
        </div>
      </section>

      {/* Ce que nous croyons — statement de foi à valider par l'équipe pastorale avant mise en ligne */}
      {/* <section className="px-4 py-14 md:py-20 bg-white">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-cmp-navy mt-3 mb-6">Ce que nous croyons</h2>
          <div className="text-gray-600 leading-relaxed text-[15px] md:text-base space-y-4 text-left">
            <p>Voici, en mots simples, ce que nous croyons et ce qui façonne notre foi au quotidien.</p>
            <p>
              <span className="font-bold text-cmp-navy">La Bible.</span> Nous croyons que la
              Bible est la Parole de Dieu, inspirée et digne de confiance. Elle est notre
              référence pour connaître Dieu et savoir comment vivre.
            </p>
            <p>
              <span className="font-bold text-cmp-navy">Dieu.</span> Nous croyons en un seul
              Dieu, qui se révèle en trois personnes : le Père, le Fils (Jésus-Christ) et le
              Saint-Esprit.
            </p>
            <p>
              <span className="font-bold text-cmp-navy">Jésus-Christ.</span> Nous croyons que
              Jésus est le Fils de Dieu, né d'une femme, mort sur la croix pour nos péchés, et
              ressuscité. C'est par lui seul que nous sommes réconciliés avec Dieu.
            </p>
            <p>
              <span className="font-bold text-cmp-navy">Le salut.</span> Nous croyons que le
              salut est un don gratuit de Dieu, reçu par la foi en Jésus-Christ — et non par nos
              propres efforts ou mérites. Personne n'a besoin de « mériter » sa place auprès de
              Dieu.
            </p>
            <p>
              <span className="font-bold text-cmp-navy">Le Saint-Esprit.</span> Nous croyons que
              le Saint-Esprit habite en chaque croyant, le console, le guide et lui donne la force
              de vivre sa foi au quotidien.
            </p>
            <p>
              <span className="font-bold text-cmp-navy">L'Église.</span> Nous croyons que
              l'Église est la famille de Dieu sur la terre — un lieu de communion, d'enseignement,
              de prière et d'entraide, appelé à porter l'Évangile jusqu'aux extrémités de la
              terre.
            </p>
            <p>
              <span className="font-bold text-cmp-navy">L'éternité.</span> Nous croyons en la
              résurrection et en une vie éternelle auprès de Dieu, promise à toute personne qui
              place sa confiance en Jésus-Christ.
            </p>
            <p>
              Ce résumé n'épuise pas la richesse de notre foi, mais il en pose les fondations. Si
              vous avez des questions, notre équipe pastorale se fera une joie d'en discuter avec
              vous.
            </p>
          </div>
        </div>
      </section> */}

      {/* Équipe pastorale — modifiable depuis /admin */}
      <section className="px-4 py-14 md:py-20 bg-cmp-cream">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <SectionLabel>Ceux qui vous accueillent</SectionLabel>
            <h2 className="text-2xl md:text-3xl font-bold text-cmp-navy mt-3">Équipe pastorale</h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
            {equipe.map(({ id, nom, fonction, bio, photo }) => (
              <div
                key={id}
                className="flex items-start gap-4 bg-white rounded-2xl rounded-tl-3xl p-5 shadow-[0_2px_10px_rgba(15,31,92,0.06)] ring-1 ring-cmp-navy/6"
              >
                <img
                  src={imageRedimensionnee(photo, 128)}
                  alt=""
                  loading="lazy"
                  className="w-16 h-16 shrink-0 aspect-square object-cover rounded-xl"
                />
                <div className="min-w-0">
                  <p className="font-bold text-cmp-navy text-sm">{nom}</p>
                  <p className="text-cmp-gold text-xs font-semibold mt-0.5">{fonction}</p>
                  {bio && <p className="text-gray-500 text-xs leading-relaxed mt-1.5">{bio}</p>}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  )
}
